define(
    "diy/undo-redo/executor/Base",
    [],
    function () {
        'use strict';
        var ExecutorBase;

        /**
         * @class module.undoRedo.Executor.Base
         * @template module.undoRedo.Executor.Base
         * @lends {module.undoRedo.Executor.Base.prototype}
         * @constructor
         */
        ExecutorBase = Klazz.extend({
            /** @type {module.undoRedo.History} */
            history: null,
            /** @type {module.undoRedo.RemoteRequest} */
            backend: null,
            /** @type {module.undoRedo.Api} */
            api: null,
            /**
             /**
             *
             * @param {module.undoRedo.History} history
             * @param {module.undoRedo.RemoteRequest} backend
             * @param {module.undoRedo.Api} api
             */
            initialize: function initialize(history, backend, api) {
                this.history = history;
                this.backend = backend;
                this.api = api;
            },
            /**
             *
             * @param {Array.<module.undoRedo.Entry>|*} items
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param {Boolean} hasLastEntry
             * @returns {*}
             */
            executeSet: function executeSet(items, result, hasLastEntry) {
                return Q(false);
            }
        });

        return ExecutorBase;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/executor/Base.js
 ** module id = 914
 ** module chunks = 0
 **/